<template>
  <div class="app-main-content">
    <div class="details-view" style="overflow: auto">
      <!--按钮-->
      <div style="margin-top: 5px">
        <el-button v-if="isEdit" type="primary" no="Cancel" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-if="isEdit" type="primary" no="Save" @click="save">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button v-if="!isEdit" type="primary" no="Back" @click="$emit('back')">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
        <el-button v-if="!isEdit" :disabled="form.status === SystemConstants.INQUIRY_STATUS_SUBMITTED.code" type="primary" no="Edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
        <el-button :disabled="isEdit || form.status === SystemConstants.INQUIRY_STATUS_SUBMITTED.code" type="primary" no="submit" @click="submitStep1">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
        <!--新建委托-->
        <el-button :disabled="isEdit || form.status !== SystemConstants.INQUIRY_STATUS_SUBMITTED.code" type="primary" no="remoteBooking" @click="remoteBooking">{{ $t('Pricing.RemoteBooking') }}</el-button>
        <el-button :disabled="isEdit" type="primary" no="print" @click="toPrint">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        <el-checkbox v-model="form.trunkLineEnable" style="margin-left: 15px" :disabled="!isEdit" no="trunkLineEnable" @change="trunkLineEnableChange">{{ $t('CargoMsg.Cargo_MainlinePrice') }}</el-checkbox>
        <el-checkbox v-model="form.prePortEnable" :disabled="!isEdit" no="prePortEnable" @change="prePortEnableChange">{{ $t('CargoMsg.Cargo_PrePortPrice') }}</el-checkbox>
        <el-checkbox v-model="form.lastMileEnable" :disabled="!isEdit" no="lastMileEnable" @change="lastMileEnableChange">{{ $t('CargoMsg.Cargo_LastMilePrice') }}</el-checkbox>
      </div>
      <div class="main-content" style="width: fit-content">
        <div style="display: flex">
          <!--基本信息-->
          <div class="section form-column">
            <el-form
              :disabled="!isEdit"
              label-width="140px"
              label-position="right"
            >
              <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
              <!--询价编号-->
              <el-form-item :label="$t('CargoMsg.Cargo_EnquiryNumber')">
                <el-input v-model="form.inquiryPriceNo" disabled />
              </el-form-item>
              <!--询价人-->
              <el-form-item :label="$t('CargoMsg.Cargo_Enquirer')">
                <cargo-user-select
                  :default-value="form.createdBy"
                  disabled
                />
              </el-form-item>
              <!--销售部门-->
              <el-form-item :label="$t('CargoMsg.Cargo_SalesDepartment')">
                <cargo-department-select
                  no="salesDepartment"
                  disabled
                  :office-id="Number(form.salesOffice)"
                  :department-id="Number(form.salesDepartment)"
                  @change="p=>{form.salesDepartment=p.value}"
                />
              </el-form-item>
              <!--销售公司-->
              <el-form-item :label="$t('CargoMsg.Cargo_SalesCompany')">
                <div style="display: flex">
                  <cargo-office-select
                    no="salesOffice"
                    disabled
                    style="width: 95%"
                    :tag-name="officeLabel"
                    :office-id="Number(form.salesOffice)"
                  />
                  <el-tooltip :content="$t('CargoMsg.CargoMsg_CurrentIdentityNotice')" placement="right-end">
                    <i
                      class="el-icon-warning"
                      style="color:orange;margin-left:10px"
                    />
                  </el-tooltip>
                </div>
              </el-form-item>
              <!--运输方式-->
              <el-form-item :label="$t('SeaExport.transportation')" required>
                <el-radio-group v-model="form.transportMode" @change="form.branchLine = form.transportMode === SystemConstants.PRICE_METHOD_DIRECT.code ? 0 : form.branchLine">
                  <el-radio :label="SystemConstants.PRICE_METHOD_DIRECT.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_DirectHaul') }}</el-radio>
                  <el-radio :label="SystemConstants.PRICE_METHOD_BRANCH.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_SideLine') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!--支线类型-->
              <el-form-item
                v-if="form.transportMode === SystemConstants.PRICE_METHOD_BRANCH.code"
                :label="$t('CargoMsg.Cargo_SideLineType')"
              >
                <cargo-advance-select
                  no="branchLine"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="form.branchLine"
                  :static-options="SystemConstants.BRANCH_LINES"
                  @parentCallBack="p=>{form.branchLine=p.value}"
                />
              </el-form-item>
              <!--货盘性质-->
              <el-form-item :label="$t('CargoMsg.Cargo_PalletType')" required>
                <cargo-advance-select
                  no="palletNature"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="form.palletNature"
                  :static-options="SystemConstants.PALLET_NATURES"
                  @parentCallBack="p=>{form.palletNature=p.value}"
                />
              </el-form-item>
              <!--货好时间-->
              <el-form-item :label="$t('SeaExport.CargoReadyDate')" required>
                <el-tabs v-model="form.cargoReadyTimeType" @tab-click="cargoReadyTimeTypeChange">
                  <el-tab-pane :disabled="!isEdit" :label="$t('CargoMsg.Cargo_Range')" :name="SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code" />
                  <el-tab-pane :disabled="!isEdit" :label="$t('CargoMsg.Cargo_Date')" :name="SystemConstants.CARGO_READY_TIME_TYPE_DATE.code" />
                </el-tabs>
                <cargo-advance-select
                  v-if="form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code"
                  no="cargoReadyTimeRange"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="form.cargoReadyTimeRange"
                  :static-options="SystemConstants.CARGO_READY_TIME_RANGES"
                  @parentCallBack="p=>{form.cargoReadyTimeRange=p.value}"
                />
                <el-date-picker
                  v-if="form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_DATE.code"
                  v-model="form.cargoReadyTimeDate"
                  no="cargoReadyTimeDate"
                  type="datetime"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
              <!--服务条款-->
              <el-form-item :label="$t('CargoMsg.Cargo_Terms')">
                <cargo-advance-select
                  no="serviceTerm"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_IncoTerm"
                  callback-method-type="value"
                  :default-value="form.serviceTerm"
                  :callback-params="{key:'incoTerm'}"
                  @parentCallBack="p => form.serviceTerm = p.value"
                />
              </el-form-item>
              <!--委托单位-->
              <!--正式客户-->
              <el-form-item
                v-if="form.customerIdType === SystemConstants.CUSTOMER_ID_TYPE_OFFICIAL.code"
                :label="$t('SeaExport.ConsignationCompany')"
              >
                <cargo-sales-company-select
                  v-if="accountObjectControlMode === 2"
                  filterable
                  no="customerId"
                  :default-value="Number(form.customerId) || ''"
                  :method-params="{customer:true,companyLob:'seaExport',active:true}"
                  :cache="false"
                  :tag-name="isZh ? 'chineseName' : 'englishName'"
                  @parentCallBack="p=>{form.customerId = p.cmpIdx + ''}"
                />
                <cargo-advance-select
                  v-else
                  filterable
                  no="customerId"
                  :select-type="TYPE_NAMES.basic_data_Company"
                  :default-value="Number(form.customerId) || ''"
                  :method-params="{customer:true,companyLob:'seaExport',active:true}"
                  :cache="false"
                  :tag-name="isZh ? 'chineseName' : 'englishName'"
                  :static-options="customerCmpList"
                  @parentCallBack="p=>{form.customerId = p.cmpIdx + ''}"
                />
              </el-form-item>
              <!--临时客户-->
              <el-form-item
                v-if="form.customerIdType === SystemConstants.CUSTOMER_ID_TYPE_TEMPORARY.code"
                :label="$t('SeaExport.Addr')"
                required
              >
                <el-input v-model="form.address" />
              </el-form-item>
              <!--装箱门点/起运地区域-->
              <el-form v-if="form.prePortEnable" :disabled="!isEdit" :inline="true" label-position="right" class="form-item-200">
                <div style="display: flex;">
                  <cargo-area
                    ref="prePortArea"
                    no="area"
                    country="CN"
                    :province.sync="form.province"
                    :city.sync="form.city"
                    :district.sync="form.districts"
                    :town.sync="form.townUuid"
                    :show-town="true"
                    :select-width="150"
                    style="display: inline-block; margin-left: 115px"
                  />
                  <el-button
                    v-if="isEdit"
                    no="aiRecognitionRegion"
                    type="primary"
                    size="mini"
                    style="height: 32px; margin: 4px 0 0 10px;"
                    @click="openAiRegionRecognition"
                  >{{ $t('SeaExport.AiRecognition') }}</el-button>
                </div>
              </el-form>
              <!--详细地址 -->
              <el-form-item
                v-if="form.prePortEnable"
                :label="$t('Partners.detailAddress')"
              >
                <el-input v-model="form.detailAddress" type="textarea" :rows="3" />
              </el-form-item>
              <!--配送地址类型-->
              <div v-if="form.lastMileEnable">
                <el-form-item :label="$t('CargoMsg.Cargo_DeliveryAddressType')" required>
                  <el-radio-group v-model="form.deliveryAddressType" @change="deliveryAddressTypeChange">
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_ThirdPartyAddress') }}</el-radio>
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_AmazonWarehouse') }}</el-radio>
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_YiCang') }}</el-radio>
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_WalmartWarehouse') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!--邮编-->
                <el-form-item
                  v-if="form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"
                  :label="$t('SeaExport.ZIP')"
                  required
                >
                  <cargo-post-code-select
                    :default-value="form.postalCode"
                    @change="postCodeChange"
                  />
                </el-form-item>
                <!--地址 由邮编中的城市，可编辑 -->
                <el-form-item
                  v-if="form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"
                  :label="$t('SeaExport.Addr')"
                >
                  <el-input v-model="form.address" />
                </el-form-item>
                <!--仓库代码-->
                <el-form-item
                  v-if="form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code ||
                    form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code ||
                    form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code"
                  :label="$t('CargoMsg.Cargo_WarehouseCode2')"
                  required
                >
                  <cargo-advance-select
                    no="overseaWarehouseCode"
                    :select-type="TYPE_NAMES.basic_data_OverseaWarehouse"
                    filterable
                    :method-params="{ifFba:true}"
                    :clearable="false"
                    tag-name="warehouseCode"
                    tag-value="warehouseCode"
                    :default-value="form.warehouseCode"
                    style="width:100%;"
                    @parentCallBack="p=>{form.warehouseCode=p.value}"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              :disabled="!isEdit"
              label-width="140px"
              label-position="right"
            >
              <!--货物信息-->
              <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
              <!--直达/中转-->
              <el-form-item :label="$t('CargoMsg.Cargo_DirectOrTransshipment')" required>
                <cargo-advance-select
                  no="directTransit"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="form.directTransit"
                  :static-options="SystemConstants.DIRECT_TRANSITS"
                  @parentCallBack="p=>{form.directTransit=p.value; form.transferPortCode=''}"
                />
              </el-form-item>
              <!--航线-->
              <el-form-item :label="$t('CargoMsg.Cargo_Airline')" required>
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Region"
                  filterable
                  :default-value="form.commerceCode"
                  style="width:100%"
                  @parentCallBack="p=>{form.commerceCode=p.value;}"
                />
              </el-form-item>
              <!--起运港-->
              <el-form-item :label="$t('CargoMsg.Cargo_POL')" required>
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="form.pol"
                  style="width:100%"
                  @parentCallBack="p=>{form.pol=p.value; fieldChange()}"
                />
              </el-form-item>
              <!--卸货港-->
              <el-form-item :label="$t('CargoMsg.Cargo_PortOfDischarge')" required>
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="form.pod"
                  style="width:100%"
                  @parentCallBack="podChange"
                />
              </el-form-item>
              <!--中转港-->
              <el-form-item
                v-if="form.directTransit === SystemConstants.DIRECT_TRANSIT_TRANSIT.code"
                :label="$t('SeaExport.TransitPort')"
                required
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="form.transferPortCode"
                  style="width:100%"
                  @parentCallBack="p=>form.transferPortCode=p.value"
                />
              </el-form-item>
              <!--货物类型-->
              <el-form-item :label="$t('SeaExport.CargoType')" required>
                <cargo-advance-select
                  no="cargoType"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_CargoType"
                  callback-method-type="value"
                  :default-value="form.cargoType"
                  :callback-params="{key:'cargoType'}"
                  @parentCallBack="cargoTypeChange"
                />
              </el-form-item>
              <!--危险品等级-->
              <el-form-item
                v-if="form.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code"
                :label="$t('SeaExport.DangerousClass')"
                required
              >
                <cargo-advance-select
                  no="dangerousGoodsLevel"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="form.dangerousGoodsLevel"
                  :static-options="SystemConstants.DANGEROUS_GOODS_LEVELS"
                  @parentCallBack="p=>{form.dangerousGoodsLevel=p.value}"
                />
              </el-form-item>
              <!--UN NO 4位整数-->
              <el-form-item
                v-if="form.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code"
                label="UN NO"
                required
              >
                <el-input-number
                  v-model="form.unNo"
                  no="unNo"
                  controls-position="right"
                  style="width: 140px;"
                  :precision="0"
                  :min="0"
                  :max="9999"
                />
              </el-form-item>
              <!--长宽高-->
              <el-form-item
                v-if="form.cargoType === ImportConstants.CARGOTYPE_OOG.code"
                :label="$t('CargoMsg.Cargo_Dimensions')"
                required
              >
                <cargo-length-width-height
                  :form="form"
                />
              </el-form-item>
              <!--温度-->
              <el-form-item
                v-if="form.cargoType === ImportConstants.CARGOTYPE_FROZEN.code"
                :label="$t('SeaExport.Temperature')"
                required
              >
                <el-input-number
                  v-model="form.temperature"
                  no="temperature"
                  controls-position="right"
                  style="width: 140px;"
                  :precision="0"
                />
                <span>℃</span>
              </el-form-item>
              <!--通风量-->
              <el-form-item
                v-if="form.cargoType === ImportConstants.CARGOTYPE_FROZEN.code"
                :label="$t('SeaExport.VentilationQuantity')"
                required
              >
                <el-input-number
                  v-model="form.ventilationQuantity"
                  no="ventilationQuantity"
                  controls-position="right"
                  style="width: 140px;"
                  :precision="0"
                />
                <span>%</span>
              </el-form-item>
              <!--品名（HS Code）-->
              <el-form-item :label="$t('CargoMsg.Cargo_NameHSCode')">
                <el-input v-model="form.cargoDescription" />
              </el-form-item>
              <!--重量-->
              <el-form-item :label="$t('CargoMsg.Cargo_Weight')" required>
                <el-input-number
                  v-model="form.weight"
                  no="weight"
                  controls-position="right"
                  style="width: 140px;"
                  :precision="2"
                  :min="0"
                />
                <span>KGS</span>
              </el-form-item>
              <!--船公司-->
              <el-form-item :label="$t('SeaExport.ShippingCompany')">
                <cargo-advance-select
                  no="carrierId"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_Company"
                  :method-params="{seaCmp:true,companyLob:'seaExport',active:true}"
                  :default-value="form.carrierId || 0"
                  placeholder=" "
                  @parentCallBack="p =>{form.carrierId=p.value || 0;fieldChange()}"
                />
              </el-form-item>
              <!--备注-->
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input v-model="form.remarks" type="textarea" :rows="3" />
              </el-form-item>
              <!--箱型箱量-->
              <span class="title">{{ $t('CargoMsg.Cargo_CartonQuantity') }}
                <i style="color: #42b983; cursor: pointer; right: 35px; top: -4px; font-size: 18px" class="el-icon-circle-plus" @click="addSeaEq" />
              </span>
              <div v-for="(seaEq, index) in form.seaEqList" :key="index">
                <div style="display: flex; align-items: center; justify-content: flex-start">
                  <el-form-item :label="$t('CargoMsg.Cargo_ContainerSize')" required>
                    <cargo-advance-select
                      style="width: 200px"
                      no="type"
                      tag-value="code"
                      filterable
                      :clearable="false"
                      :default-value="seaEq.type"
                      :static-options="SystemConstants.SEA_EQ_TYPES"
                      @parentCallBack="p=>{seaEq.type=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_AmountNumber')" required>
                    <el-input-number
                      v-model="seaEq.quantity"
                      no="quantity"
                      :clearable="false"
                      controls-position="right"
                      style="width: 140px;"
                      :precision="0"
                      :min="1"
                      :max="99"
                    />
                  </el-form-item>
                  <i style="color: #f56c6c; cursor: pointer; right: 35px; top: 5px; font-size: 18px" class="el-icon-remove" @click="deleteSeaEq(index)" />
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <!--匹配报价-->
        <div class="section" style="width:100%">
          <div>
            <span class="title">{{ $t('CargoMsg.Cargo_MatchQuote') }}</span>
            <el-button v-if="!form.uuid || form.status === SystemConstants.INQUIRY_STATUS_DRAFT.code" style="margin-left: 15px" type="primary" no="" @click="matchPriceClick">{{ $t('CargoMsg.Cargo_Match') }}</el-button>
          </div>
          <price-combination-result
            :type="SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code"
            :inquiry-form="form"
            :quotations="quotations"
            :trunk-line-enable="form.trunkLineEnable"
            :pre-port-enable="form.prePortEnable"
            :last-mile-enable="form.lastMileEnable"
            :trunk-line-data="trunkLineData"
            :pre-port-data="prePortData"
            :last-mile-data="lastMileData"
            :selected-trunk-line-data="selectedTrunkLineData"
            :selected-pre-port-data="selectedPrePortData"
            :selected-last-mile-data="selectedLastMileData"
            :trunk-line-data-total="trunkLineDataTotal"
            :pre-port-data-total="prePortDataTotal"
            :last-mile-data-total="lastMileDataTotal"
            :data-type="dataType"
            @radioClickHandler="radioClickHandler"
            @pagination="pagination"
          />
        </div>
        <!--文件历史-->
        <div v-if="form && form.uuid" class="section" style="width:100%">
          <span class="title">{{ $t('Pricing.FileHistory') }}</span>
          <el-form v-if="isEdit" class="section">
            <el-row>
              <el-col :span="24">
                <el-button no="toFileQuery" type="primary" @click="toFileQuery">{{ $t('FileHistory.Refresh') }}</el-button>
                <el-button v-permission="['button_FileHistory_fileUpload']" no="upload" type="primary" @click="file.cloudFile.visible=true">{{ $t('FileHistory.Upload') }}</el-button>
                <el-button v-permission="['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']" no="fileRemove" type="danger" @click="fileRemove">{{ $t('FileHistory.Delete') }}</el-button>
                <el-button no="fileDownload" type="primary" @click="fileDownload">{{ $t('FileHistory.BatchDownload') }}</el-button>
                <el-button no="fileSendEmail" type="primary" @click="fileSendEmail">{{ $t('FileHistory.SendEmail') }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <el-form class="section" :disabled="!isEdit">
            <el-row>
              <el-col :span="24">
                <cargo-ag-grid
                  key="25070801"
                  config-module="25070801"
                  :grid-params.sync="file.gridParams"
                  :grid-options="file.gridOptions"
                  :column-defs="file.columnDefs"
                  :row-data="file.rowData"
                  style="flex: 1"
                  @gridReady="params=>{file.gridApi=params.api}"
                />
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <inquiry-responsible-person-dialog
      v-if="inquiryResponsiblePersonDialog.visible"
      :visible.sync="inquiryResponsiblePersonDialog.visible"
      :show-trunk-line="form.trunkLineEnable && !selectedTrunkLineData"
      :show-pre-port="form.prePortEnable && !selectedPrePortData"
      :show-last-mile="form.lastMileEnable && !selectedLastMileData"
      :trunk-line-person-data="inquiryResponsiblePersonDialog.trunkLinePersonData"
      :pre-port-person-data="inquiryResponsiblePersonDialog.prePortPersonData"
      :last-mile-person-data="inquiryResponsiblePersonDialog.lastMilePersonData"
      @confirm="submitStep2"
    />

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="file.cloudFile.visible"
      :job="fileCloudFileJob"
      :lob="file.cloudFile.lob"
      @uploadDone="toFileQuery"
    />

    <!-- 文件-属性详情 -->
    <el-dialog
      v-if="file.isShowingDetailForm"
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible="file.isShowingDetailForm"
      :title="file.showDetailTitle"
      width="450px"
      @close="() => file.isShowingDetailForm = false"
    >
      <cargo-ag-grid
        :grid-options="file.gridOptionsFileDetail"
        :column-defs="file.columnDefsFileDetail"
        :row-data="file.rowDataFileDetail"
        style="width:400px;height: 300px"
        @gridReady="params=>file.gridApiFileDetail=params.api"
      />
    </el-dialog>

    <!-- 发送邮件弹窗 -->
    <send-email-dialog
      v-if="file.sendEmailDialog.visible"
      ref="file.sendEmailDialog"
      :visible.sync="file.sendEmailDialog.visible"
      :context="null"
      :job="fileCloudFileJob"
      source="quotationDetailDialog"
      :send-email-data="file.sendEmailDialog"
    />

    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :prompt-key="aiRecognitionDialog.promptKey"
      :call-back="aiRecognitionDialog.callBack"
      :title="$t('CargoMsg.CargoMsg_AIAddressRecognition')"
      :placeholder="aiRecognitionDialog.placeholder"
    />

    <!--打印 弹窗-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import PriceCombinationResult from '@/components/Cargo/Price/priceCombinationResult'
import InquiryResponsiblePersonDialog from '@/components/Cargo/Inquiry/inquiryResponsiblePersonDialog'
import { InquiryPrice } from '@/class/model/price/InquiryPrice'
import InquiryDetail from '@/components/Cargo/Inquiry/inquiryDetail'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import cargoPostCodeSelect from '@/components/Cargo/Common/cargoPostCodeSelect'
import cargoLengthWidthHeight from '@/components/Cargo/Common/cargoLengthWidthHeight'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import FileHistoryHp from '@/views/cargo/v0/Files/FileHistory/FileHistoryHp'
import { DocumentManage } from '@/utils/commonUtil'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import sendEmailDialog from '@/components/Cargo/Job/sendEmailDialog'

export default {
  name: 'InquirySeaFclDetail', // 整箱询价详情
  components: {
    cargoCloudFileUpload, sendEmailDialog, CargoAiRecognitionDialog, cargoTemplateSelectorDialog,
    InquiryResponsiblePersonDialog, cargoArea, cargoPostCodeSelect, cargoLengthWidthHeight, cargoDepartmentSelect, cargoOfficeSelect,
    PriceCombinationResult, cargoAgGridWrapper, cargoAdvanceSelect, cargoCompanySelect, cargoUserSelect, CargoSalesCompanySelect },
  props: {
    lob: { type: String, default: '' },
    source: { type: String, default: '' }
  },
  data() {
    return {
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        callBack: null,
        promptKey: SystemConstants.REGION_PROMPT_KEY.code,
        placeholder: '',
        visible: false
      },
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'SEA_FCL_INQUIRY_PRICE',
        data: {
          INQUIRY_PRICE_UUID: ''
        }
      },
      fileHistoryHp: new FileHistoryHp(this),
      documentManage: new DocumentManage(),
      file: {
        queryKey: 'inquiryPriceUuid',
        docType: [],
        fileName: '',
        fileIdList: '',
        storageURL: '',
        fileTypeMap: new Map(),
        cloudFile: {
          visible: false,
          job: new InquiryPrice(),
          lob: ''
        },
        sendEmailDialog: {
          visible: false,
          emailTitle: '',
          emailContent: '',
          detailCode: '',
          fileIdList: '',
          fileList: []
        },
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 选中 文件类型
          onCellFocused: (event) => {
            FileHistoryHp.onFileTypeCellFocused(event, this)
          },
          treeData: true,
          getDataPath: data => {
            return (data.path || '').split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('FileHistory.fileName'),
            field: 'fileName',
            width: 240,
            headerCheckboxSelection: false,
            valueFormatterParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return false
              }
            }
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: '',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 55,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('FileHistory.fileVersion'),
            field: 'fileVersion',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.jobType'),
            field: 'fileType',
            width: 200,
            valueFormatter: params => {
              return FileHistoryHp.fileTypeLabelFunction(params.value, this)
            }
          },
          {
            headerName: this.$t('FileHistory.fileType'),
            field: 'fileFormat',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.fileSize'),
            field: 'fileSize',
            width: 200,
            valueFormatter: params => {
              return FileHistoryHp.fileSizeColumnLabel(params.value, this)
            }
          },
          {
            headerName: this.$t('FileHistory.createdBy'),
            field: 'createdBy',
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
            }
          },
          {
            headerName: this.$t('FileHistory.createdDate'),
            field: 'createDate',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.Details'),
            field: 'fileId',
            width: 200,
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
              return `<a onclick="${methodPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.Details')}</a>`
            }
          },
          {
            headerName: this.$t('FileHistory.view'),
            field: 'fileId',
            width: 200,
            cellRenderer: params => {
              const methodOnFileViewPath = this.documentManage.getPath('onFileView')
              return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.view')}</a>`
            }
          }
        ],
        fileTypeEditor: {
          visible: false,
          fileId: '',
          fileCategory: ''
        },
        gridApiFileDetail: null,
        gridOptionsFileDetail: {
          context: {
            componentParent: this
          }
        },
        columnDefsFileDetail: [
          {
            headerName: this.$t('FileHistory.tagName'),
            field: 'key',
            width: 150
          },
          {
            headerName: this.$t('FileHistory.tagValue'),
            field: 'val',
            width: 200
          }
        ],
        rowDataFileDetail: [],
        isShowingDetailForm: false,
        showDetailTitle: ''
      },
      officeLabel: 'chineseName', accountObjectControlMode: 0,
      type: SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code,
      ColumnUtils, ImportConstants,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      isEdit: false, // 是否 编辑
      form: new InquiryPrice().fillDefaultValue().getData(),
      originForm: {},
 	      trunkLineData: [],
      quotations: [],
      trunkLineDataTotal: 0,
      prePortDataTotal: 0,
      lastMileDataTotal: 0,
      filter: null,
      prePortData: [],
      lastMileData: [],
      selectedPrePortData: null,
      selectedLastMileData: null,
      selectedTrunkLineData: null,
      inquiryResponsiblePersonDialog: {
        visible: false,
        trunkLinePersonData: [],
        prePortPersonData: [],
        lastMilePersonData: []
      },
      lastFilter: null,
      customerCmpList: null // 委托单位数据源
    }
  },
  computed: {
    // 匹配报价中的数据类型 1-运价 2-报价
    dataType() {
      return (!this.form.uuid || this.form.status === SystemConstants.INQUIRY_STATUS_DRAFT.code) ? SystemConstants.DATA_TYPE_PRICE.code : SystemConstants.DATA_TYPE_QUOTATION.code
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    fileCloudFileJob() { // 文件操作使用
      return new InquiryPrice(this.form)
    }
  },
  watch: {
    'form.seaEqList': {
      async handler() {
        this.fieldChange()
      }
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler(val) {
        await cache.load(cacheName.CONFIG)
        this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode'))
        if (!this.form.uuid) {
          this.form.salesOffice = val
        }
        this.$emit('loadSalesPrivateCustomer')
      }
    },
    '$store.getters.currentDeptId': {
      async handler(val) {
        if (!this.form.uuid) {
          this.form.salesDepartment = val
        }
      }
    }
  },
  async beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.fileHistoryHp.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.fileHistoryHp.onFileView(value)
    })
  },
  created() {
    const configs = this.$store.state.settings.partnerLabelSettings
    const curConfig = configs.find(config => config.autoKey === 'auto_office')
    this.officeLabel = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
  },
  methods: {
    ...InquiryDetail.methods,

    openAiRegionRecognition() {
      this.aiRecognitionDialog.multimodal = false
      this.aiRecognitionDialog.promptKey = SystemConstants.REGION_PROMPT_KEY.code
      this.aiRecognitionDialog.placeholder = this.$t('SeaExport.RecognitionTextTip')
      this.aiRecognitionDialog.callBack = (jsonStr) => this.aiRecognitionRegionPostHandler(jsonStr)
      this.aiRecognitionDialog.visible = true
    },

    async aiRecognitionRegionPostHandler(jsonStr) {
      console.log('aiRecognitionRegionPostHandler', jsonStr)
      const parsed = this.safeJsonParse(jsonStr)
      const region = Array.isArray(parsed) ? parsed[0] : parsed
      if (!region) {
        return
      }

      const provinceName = region.province
      const cityName = region.city
      const districtName = region.district
      const streetName = region.street
      const detailAddress = region.detail
      if (detailAddress) {
        this.form.detailAddress = String(detailAddress).trim()
      }

      if (provinceName || cityName || districtName) {
        await this.applyRegionByNames({ provinceName, cityName, districtName, streetName })
      }
    },

    safeJsonParse(input) {
      if (!input) {
        return null
      }
      if (typeof input !== 'string') {
        return input
      }
      try {
        return JSON.parse(input)
      } catch (e) {
        return null
      }
    },

    normalizeCnDivisionName(name) {
      return String(name || '')
        .trim()
        .replace(/\s+/g, '')
        .replace(
          /(\u7701|\u5e02|\u533a|\u53bf|\u81ea\u6cbb\u5dde|\u81ea\u6cbb\u53bf|\u81ea\u6cbb\u533a|\u7279\u522b\u884c\u653f\u533a)$/g,
          ''
        )
    },

    normalizeCnTownName(name) {
      return String(name || '')
        .trim()
        .replace(/\s+/g, '')
        .replace(/(街道|镇|乡|苏木|民族乡)$/g, '')
    },

    findDivisionByName(divisionList, name) {
      const normalized = this.normalizeCnDivisionName(name)
      if (!normalized) {
        return null
      }

      const exact = (divisionList || []).find((d) => this.normalizeCnDivisionName(d?.name) === normalized)
      if (exact) {
        return exact
      }

      return (divisionList || []).find((d) => this.normalizeCnDivisionName(d?.name).includes(normalized))
    },

    findTownByName(townList, name) {
      const normalized = this.normalizeCnTownName(name)
      if (!normalized) {
        return null
      }

      const exact = (townList || []).find((t) => this.normalizeCnTownName(t?.name) === normalized)
      if (exact) {
        return exact
      }

      return (townList || []).find((t) => this.normalizeCnTownName(t?.name).includes(normalized))
    },

    async ensurePrePortAreaReady() {
      const area = this.$refs.prePortArea
      if (!area) {
        return null
      }
      if (Array.isArray(area.provinceList) && area.provinceList.length > 0) {
        return area
      }

      if (typeof area.init === 'function') {
        await area.init('CN')
      }
      return area
    },

    async applyRegionByNames({ provinceName, cityName, districtName, streetName }) {
      const area = await this.ensurePrePortAreaReady()
      if (!area) {
        return
      }

      const log = (...args) => console.log('[AI-REGION]', ...args)
      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
      const waitUntil = async(fn, timeoutMs = 2000, intervalMs = 50) => {
        const deadline = Date.now() + timeoutMs
        while (Date.now() < deadline) {
          if (fn()) {
            return true
          }
          await sleep(intervalMs)
        }
        return false
      }

      log('input', { provinceName, cityName, districtName, streetName })
      log('provinceList', Array.isArray(area.provinceList) ? area.provinceList.length : null)

      const province = this.findDivisionByName(area.provinceList, provinceName)
      if (!province?.code) {
        log('province not found', {
          provinceName,
          normalized: this.normalizeCnDivisionName(provinceName),
          sample: (area.provinceList || []).slice(0, 10).map((d) => d?.name)
        })
        return
      }
      this.form.province = province.code
      log('province matched', { name: province.name, code: this.form.province, type: typeof this.form.province })

      if (typeof area.getDivisionByParentCode === 'function') {
        await area.getDivisionByParentCode(province.code, 2)
      }
      const cityListReady = await waitUntil(() => Array.isArray(area.cityList) && area.cityList.length > 0)
      log('cityList ready', cityListReady, Array.isArray(area.cityList) ? area.cityList.length : null)
      if (Array.isArray(area.cityList) && area.cityList.length > 0) {
        log(
          'cityList sample',
          area.cityList.slice(0, 10).map((d) => ({ name: d?.name, code: d?.code, externalCode: d?.externalCode }))
        )
      }

      const city = this.findDivisionByName(area.cityList, cityName)
      if (!city?.code) {
        log('city not found', {
          cityName,
          normalized: this.normalizeCnDivisionName(cityName),
          sample: (area.cityList || []).slice(0, 20).map((d) => d?.name)
        })
        return
      }
      this.form.city = city.code
      log('city matched', { name: city.name, code: this.form.city, type: typeof this.form.city })
      log('city exists strict?', (area.cityList || []).some((d) => d?.code === this.form.city))
      log('city exists string?', (area.cityList || []).some((d) => String(d?.code) === String(this.form.city)))
      if (typeof area.getDivisionByParentCode === 'function') {
        await area.getDivisionByParentCode(city.code, 3)
      }
      const districtListReady = await waitUntil(() => Array.isArray(area.districtList) && area.districtList.length > 0)
      log('districtList ready', districtListReady, Array.isArray(area.districtList) ? area.districtList.length : null)
      if (Array.isArray(area.districtList) && area.districtList.length > 0) {
        log(
          'districtList sample',
          area.districtList.slice(0, 10).map((d) => ({ name: d?.name, code: d?.code, externalCode: d?.externalCode }))
        )
      }

      const district = this.findDivisionByName(area.districtList, districtName)
      if (!district?.code) {
        log('district not found', {
          districtName,
          normalized: this.normalizeCnDivisionName(districtName),
          sample: (area.districtList || []).slice(0, 30).map((d) => d?.name)
        })
        return
      }
      this.form.districts = district.code
      log('district matched', { name: district.name, code: this.form.districts, type: typeof this.form.districts })
      log('district exists strict?', (area.districtList || []).some((d) => d?.code === this.form.districts))
      log('district exists string?', (area.districtList || []).some((d) => String(d?.code) === String(this.form.districts)))

      if (streetName && typeof area.getDivisionByParentCode === 'function') {
        await area.getDivisionByParentCode(district.code, 4)
        const townListReady = await waitUntil(() => Array.isArray(area.townList) && area.townList.length > 0)
        log('townList ready', townListReady, Array.isArray(area.townList) ? area.townList.length : null)
        if (Array.isArray(area.townList) && area.townList.length > 0) {
          log('townList sample', area.townList.slice(0, 10).map((t) => ({ name: t?.name, uuid: t?.uuid })))
        }

        const town = this.findTownByName(area.townList, streetName)
        if (!town?.uuid) {
          log('town not found', {
            streetName,
            normalized: this.normalizeCnTownName(streetName),
            sample: (area.townList || []).slice(0, 30).map((t) => t?.name)
          })
          return
        }
        this.form.townUuid = town.uuid
        log('town matched', { name: town.name, uuid: this.form.townUuid })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-column {
  width: 980px !important;
}
</style>
